<p-tabView [activeIndex]="tab" (activeIndexChange)="navigate($event)">
  <p-tabPanel header="Solicitações de reenvio">
    <ng-template pTemplate="content">
      <app-table
        [cols]="cols"
        [service]="shippingOrderService"
        [findPage]="findPage"
        [sortOrder]="1"
        [addButton]="false"
        dataKey="shippingOrderIdResend"
        expandField="items"
        [expansionCols]="productCols"
        (rowExpand)="findItems($event.$event, $event.service)"
        modelName="solicitações"
        [dropdownFilters]="dropdownFilters"
        [expandPaginator]="false"
        [rowBackground]="status() === 0 ? productBackground : undefined"
        [changeColumns]="true"
        [extraButton]="true"
        (extraButtonClick)="recalculateStocks()"
        extraLabel="Atualizar estoques"
        extraButtonTooltip="Verifica o estoque de pedidos AG. ESTOQUE"
        extraButtonTooltipPosition="bottom"
        selectionActionLabel="Revisar pedidos"
        selectionActionIcon="pi pi-file-check"
        selectionActionTooltip="Revisa os pedidos selecionados"
        selectionActionClass="p-button-highlight"
        (emitSelection)="validateResendOrders($event)"
        [rowSelectable]="rowSelectable"
        [hasChildren]="hasChildren"
        [multiSelectFilter]="true"
      />
    </ng-template>
  </p-tabPanel>
  <p-tabPanel header="Solicitações de reenvio da loja">
    <ng-template pTemplate="content">
      <app-table
        [cols]="shopCols"
        [service]="shippingOrderService"
        pageFunctionName="findShopResendRequests"
        [sortOrder]="1"
        [addButton]="false"
        modelName="solicitações"
        [dropdownFilters]="dropdownFilters"
        [changeColumns]="true"
        [multiSelectFilter]="true"
      />
    </ng-template>
  </p-tabPanel>
</p-tabView>
<p-toast />
<p-dialog
  [(visible)]="showModal"
  *ngIf="selectionList?.length > 0"
  header="Revisão de pedidos"
  [style]="{ width: '90vw' }"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
>
  <div>
    <app-table
      [addButton]="false"
      [cols]="colsReview"
      [elements]="selectionList"
      [sortOrder]="1"
      modelName="Pedidos de reenvio"
      tableTitle="Pedidos para revisão"
      [exportExcel]="false"
      [exportPdf]="false"
      [lazy]="false"
    />
    <div class="modal-buttons">
      <p-button
        label="Aprovar"
        icon="pi pi-check"
        (onClick)="approveResendOrders()"
        styleClass="p-button-success"
      />
      <p-button
        label="Rejeitar"
        icon="pi pi-times"
        (onClick)="rejectResendOrders()"
        styleClass="p-button-danger"
      />
    </div>
  </div>
</p-dialog>
